<template>
  <Modal
    class="reward-modal"
    :container-style="{
      height: 'calc(100% - 1rem)',
      margin: '0.5rem',
      backgroundColor: '#f3efea',
      position: 'relative',
    }"
  >
    <div slot="header" class="reward-modal__header">
      <a class="reward-modal__button-close" @click.prevent.stop="$emit('close')">
        <img src="~assets/images/icons/icon-close-inverse/icon-close-inverse.png">
      </a>
      <img :src="reward.image_url" class="reward-modal__img">
    </div>
    <div slot="body" class="reward-modal__body">
      <div class="reward-modal__body-title">
        <h6 class="reward-modal__name">
          {{ reward.name }}
        </h6>
        <div class="reward-modal__value">
          <Badge :text="reward.formatted_amount" :color="globalPrimaryColor" />
          &nbsp;&nbsp;Pour
          <strong :style="globalStylePrimaryColorText">
            {{ reward.value }} points
          </strong>
        </div>
      </div>
      <div class="reward-modal__body-description">
        <div>{{ reward.description }}</div>
        <div class="reward-modal__wrapper-link-cgu">
          <a class="reward-modal__link-cgu" @click="openIframe">
            Lire les conditions d'utilisations
          </a>
        </div>
      </div>
    </div>
    <div v-if="!selectionDisabled" slot="footer" class="reward-modal__footer">
      <div class="modal-reward__wrapper-button-burn">
        <a class="modal-reward__button-burn" @click="$emit('selectReward')">
          Choisir comme prochain cadeau
        </a>
      </div>
    </div>
  </Modal>
</template>

<script>
import { mapState } from 'vuex'

import Badge from '~/components/elements/Badge'
import Modal from '~/components/elements/Modal'

import MixinPrimaryColor from '~/mixins/primaryColor'

import getIframePath from '~/utils/functions/getIframePath'

export default {
  components: { Badge, Modal },
  mixins: [MixinPrimaryColor],
  props: {
    selectionDisabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('layout', { reward: 'catalogModalReward' }),
  },
  methods: {
    openIframe () {
      this.$router.push({ path: getIframePath(this.reward.name, this.reward.terms_url) })
    },
  },
}
</script>

<style scoped>
.reward-modal__header {
  height: 40vh;
  background-color: white;
  text-align: center;
  border-radius: 1rem 1rem 0 0;
}
.reward-modal__img {
  max-height: 100%;
  max-width: 100%;
}
.reward-modal__button-close {
  cursor: pointer;
  position: absolute;
  top: 0.5rem;
  right: 1rem;
}

.reward-modal__body {
  max-height: calc(60vh - 1.5rem);
}

.reward-modal__body-title {
  margin: 1% 0;
  padding: 1rem;
  background-color: white;
}
.reward-modal__name {
  margin: 0;
}
.reward-modal__value {
  font-size: 1.2rem;
  margin-top: 0.5rem;
}

.reward-modal__body-description {
  padding: 1rem;
  font-size: 1.2rem;
  overflow: auto;
  /*
    1.5 => margins
    6   => reward-modal__body-title
    5   => reward-modal__footer
  */
  max-height: calc(60vh - 1.5rem - 6rem - 5rem);
}
.reward-modal__wrapper-link-cgu {
  margin-top: 1rem;
}
.reward-modal__link-cgu {
  color: #5babf3;
  text-transform: uppercase;
  cursor: pointer;
}

.reward-modal__footer {
  padding: 1rem;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}
.modal-reward__button-burn {
  display: block;
  cursor: pointer;
  text-align: center;
  text-transform: uppercase;
  text-decoration: none;
  background-color: #ae2d26;
  color: white;
  padding: 0.5rem 0;
  border-radius: 0.2rem;
  box-shadow: 0 0 0.1rem rgba(0, 0, 0, 0.8);
}
.modal-reward__button-burn:hover {
  color: white;
  box-shadow: 0 0 1rem black;
}
.modal-reward__button-burn:active {
  box-shadow: 0 0 0.2rem black inset;
}
</style>
